<template>
    <q-card-section class="modal-content">
        <span class="modal-title">Вход в личный кабинет</span>
        <div class="q-gutter-md q-mb-xs">
            <q-radio v-model="type" val="phone_number" label="по телефону" />
            <q-radio v-model="type" val="email" label="по E-mail" />
        </div>

        <div class="row q-col-gutter-none" id="modal-login-form">
            <div class="col-12" v-show="$store.state.auth.login.type === 'phone_number'" >
                <q-input
                    outlined
                    class="required min-field-bottom"
                    v-model="phone_number"
                    @blur="blurPhoneNumber"
                    @focus="focusPhoneNumber"
                    mask="+7 (###) ###-##-##"
                    label="Ваш телефон"
                    :fill-mask="fillPhoneNumberMask"
                    :error-message="getError('phone_number')"
                    :error="hasError('phone_number')"
                />
            </div>
            <div class="col-12" v-show="$store.state.auth.login.type === 'email'">
                <q-input
                    outlined
                    class="required min-field-bottom"
                    v-model="email"
                    label="Ваш email"
                    :error-message="getError('email')"
                    :error="hasError('email')" />
            </div>
            <div class="col-12">
                <q-input
                    class="required min-field-bottom"
                    outlined
                    v-model="password"
                    label="Пароль"
                    :type="isPwd ? 'password' : 'text'"
                    :error-message="getError('password')"
                    :error="hasError('password')">
                    <template v-slot:append>
                        <q-icon
                            :name="isPwd ? 'visibility_off' : 'visibility'"
                            class="cursor-pointer"
                            @click="isPwd = !isPwd"
                        />
                    </template>
                </q-input>
            </div>
            <div class="form-sign-links col-12 mt-2">
                <span @click.prevent="setForm('remember')">Забыли пароль?</span>
            </div>
            <div class="col-12 q-mt-md">
                <q-btn class="full-width" label="Войти" @click.prevent="submitLogin" />
            </div>
        </div>
        <div class="social q-mb-md">
            <div class="social-title q-my-lg"><span>Через социальную сеть</span></div>
            <div class="social-items">
                <a class="social-item social-item--vk" :href="getSocialUrl('vkontakte')">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="19px" height="19px">
                        <path fill="currentColor" d="M545 117.7c3.7-12.5 0-21.7-17.8-21.7h-58.9c-15 0-21.9 7.9-25.6 16.7 0 0-30 73.1-72.4 120.5-13.7 13.7-20 18.1-27.5 18.1-3.7 0-9.4-4.4-9.4-16.9V117.7c0-15-4.2-21.7-16.6-21.7h-92.6c-9.4 0-15 7-15 13.5 0 14.2 21.2 17.5 23.4 57.5v86.8c0 19-3.4 22.5-10.9 22.5-20 0-68.6-73.4-97.4-157.4-5.8-16.3-11.5-22.9-26.6-22.9H38.8c-16.8 0-20.2 7.9-20.2 16.7 0 15.6 20 93.1 93.1 195.5C160.4 378.1 229 416 291.4 416c37.5 0 42.1-8.4 42.1-22.9 0-66.8-3.4-73.1 15.4-73.1 8.7 0 23.7 4.4 58.7 38.1 40 40 46.6 57.9 69 57.9h58.9c16.8 0 25.3-8.4 20.4-25-11.2-34.9-86.9-106.7-90.3-111.5-8.7-11.2-6.2-16.2 0-26.2.1-.1 72-101.3 79.4-135.6z"></path>
                    </svg>
                </a>
                <a class="social-item social-item--yandex" :href="getSocialUrl('yandex')">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" width="19px" height="19px">
                        <path fill="currentColor" d="M153.1 315.8L65.7 512H2l96-209.8c-45.1-22.9-75.2-64.4-75.2-141.1C22.7 53.7 90.8 0 171.7 0H254v512h-55.1V315.8h-45.8zm45.8-269.3h-29.4c-44.4 0-87.4 29.4-87.4 114.6 0 82.3 39.4 108.8 87.4 108.8h29.4V46.5z"></path>
                    </svg>
                </a>
            </div>
        </div>
    </q-card-section>
</template>

<script>
    import { mapGetters, mapMutations, mapActions } from 'vuex';
    import phoneNumberMixin from './../../../mixins/phone_number';

    export default {
        name: 'Login',
        mixins: [
            phoneNumberMixin,
        ],
        data () {
            return {
                isPwd: true,
                passwordType: 'password',
                socialUrl: '/auth/:social/redirect',
            }
        },
        methods: {
            ...mapMutations('auth', [
                'hideModal',
                'setForm',
            ]),
            ...mapActions('auth', [
                'login',
            ]),
            getSocialUrl(social) {
                return this.socialUrl.replace(':social', social);
            },
            togglePasswordType () {
                this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
            },
            setPhoneNumberCallback (value) {
                return this.phone_number = value ? value : '';
            },
            getPhoneNumber () {
                return this.phone_number;
            },
            submitLogin () {
                let _this = this;
                _this.login();
            }
        },
        computed: {
            ...mapGetters('auth', [
                'hasError',
                'getError'
            ]),
            phone_number: {
                get () {
                    return this.$store.state.auth.login.phone_number;
                },
                set (value) {
                    this.$store.commit('auth/setFormValue', {
                        key: 'phone_number',
                        value: value
                    });
                }
            },
            email: {
                get () {
                    return this.$store.state.auth.login.email;
                },
                set (value) {
                    this.$store.commit('auth/setFormValue', {
                        key: 'email',
                        value: value
                    });
                }
            },
            password: {
                get () {
                    return this.$store.state.auth.login.password;
                },
                set (value) {
                    this.$store.commit('auth/setFormValue', {
                        key: 'password',
                        value: value
                    });
                }
            },
            type: {
                get () {
                    return this.$store.state.auth.login.type;
                },
                set (value) {
                    this.$store.commit('auth/setFormValue', {
                        key: 'type',
                        value: value
                    });
                }
            },
        }
    }
</script>
